module.exports = __webpack_public_path__ + "about.png?d0fb07a0e47411647fa0bad7fa621bca";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about.png
// module id = 41
// module chunks = 0